import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { alpha, Box, useTheme } from '@mui/material';
import React from 'react';

import { TableTooltip } from '../../../../_mui/_components_/TableTooltip';
import StatusCell from '../StatusCell/StatusCell';

interface IProps {
  value: string;
  errorMessage?: string;
  showStatus?: boolean;
  hasRowErrors?: boolean;
  disabled?: boolean;
}

const CellWithError: React.FC<IProps> = ({ value, errorMessage, showStatus, hasRowErrors, disabled }) => {
  const theme = useTheme();
  const hasError = !!errorMessage && !disabled;

  return (
    <TableTooltip title={errorMessage || ''} isDisabled={!hasError}>
      <Box sx={{ display: 'flex', alignItems: 'center', height: '100%', width: '100%' }}>
        {showStatus && <StatusCell hasErrors={hasRowErrors || false} />}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            bgcolor: disabled ? 'grey.100' : hasError ? alpha(theme.palette.error.light, 0.1) : 'transparent',
            color: disabled ? 'text.disabled' : 'inherit',
            height: '100%',
          }}
        >
          <Box
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              paddingLeft: 1,
            }}
          >
            {value}
          </Box>
          {hasError && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexShrink: 0,
                paddingRight: 1,
              }}
            >
              <ErrorOutlineIcon color="error" fontSize="small" />
            </Box>
          )}
        </Box>
      </Box>
    </TableTooltip>
  );
};

export default React.memo(CellWithError);
